import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useTranslation } from "react-i18next";

export default function StaffLogin() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("staff_token", data.token);
      nav("/staff");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#F9F8F6] flex items-center justify-center px-6">
      <form onSubmit={submit} className="max-w-md w-full bg-white border border-stone-200 p-10">
        <div className="eyebrow">Plan It Studio</div>
        <h1 className="font-serif text-3xl mt-3 text-stone-900" data-testid="stafflogin-title">{t("nav.staff")}</h1>
        <div className="mt-8 space-y-5">
          <div>
            <label className="block text-xs uppercase tracking-widest text-stone-600 mb-2">{t("staff.email")}</label>
            <input data-testid="stafflogin-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-transparent border-b border-stone-300 focus:border-[#D06D4D] outline-none py-2" />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-widest text-stone-600 mb-2">{t("staff.password")}</label>
            <input data-testid="stafflogin-password" required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-transparent border-b border-stone-300 focus:border-[#D06D4D] outline-none py-2" />
          </div>
        </div>
        <button data-testid="stafflogin-submit" disabled={loading} className="mt-8 w-full bg-[#D06D4D] hover:bg-[#b95a3d] text-white py-3 rounded-full text-sm font-semibold disabled:opacity-60">
          {loading ? "…" : t("staff.login")}
        </button>
      </form>
    </div>
  );
}
